import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button as ButtonUI } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function Dropdown({ title, hidden, children }) {
  const [hiddenDropdown, setHiddenDropdown] = useState(hidden);
  const onChangeToggle = () => setHiddenDropdown(!hiddenDropdown);

  return (
    <Grid container justifyContent="center" marginTop={1}>
      <Grid container justifyContent="space-around">
        <Grid item xs={10} sm={10}>
          <h3> {title} </h3>
        </Grid>
        <Grid
          item
          xs={1}
          sm={1}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ButtonUI color="inherit" onClick={() => onChangeToggle()}>
            {hiddenDropdown ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </ButtonUI>
        </Grid>
        {!hiddenDropdown && (
          <Grid item xs={12} sm={12}>
            {children}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

Dropdown.defaultProps = {
  hidden: true,
};

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
export default Dropdown;
